/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BucketPathPartitionSpec } from '../models/BucketPathPartitionSpec';
import { FileFormat } from '../models/FileFormat';
import { PartitionType } from '../models/PartitionType';

export class S3SourceProperties {
  /**
  * The S3 bucket name
  */
  'bucket': string;
  /**
  * The S3 prefix (path) within the bucket
  */
  'prefix'?: string;
  /**
  * The AWS region where the bucket is located
  */
  'region': string;
  /**
  * The AWS account ID that owns the bucket
  */
  'ownerAccountId': string;
  'fileFormat': FileFormat;
  'partitionType': PartitionType;
  'bucketPathPartitionSpec': BucketPathPartitionSpec;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "bucket",
      "baseName": "bucket",
      "type": "string",
      "format": ""
    },
    {
      "name": "prefix",
      "baseName": "prefix",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "ownerAccountId",
      "baseName": "ownerAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "fileFormat",
      "baseName": "fileFormat",
      "type": "FileFormat",
      "format": ""
    },
    {
      "name": "partitionType",
      "baseName": "partitionType",
      "type": "PartitionType",
      "format": ""
    },
    {
      "name": "bucketPathPartitionSpec",
      "baseName": "bucketPathPartitionSpec",
      "type": "BucketPathPartitionSpec",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return S3SourceProperties.attributeTypeMap;
  }

  public constructor() {
  }
}



